<template>
  <header class="site-header">
    <div class="header-inner">
      <router-link to="/" class="brand">
        <img class="brand-logo" src="/acaa-01.png" alt="ACCA" decoding="async" />
        
      </router-link>
      <div class="header-right">
        <nav class="nav">
          <router-link class="nav-link" to="/" exact-active-class="is-active">首页</router-link>
          <router-link class="nav-link" to="/query" active-class="is-active">证书查询</router-link>
          <router-link class="nav-link" to="/about" active-class="is-active">关于我们</router-link>
        </nav>
        <div class="theme-toolbar">
          <button
            type="button"
            class="theme-icon-btn"
            :aria-label="theme === 'dark' ? '切换为浅色模式' : '切换为深色模式'"
            :title="theme === 'dark' ? '浅色模式' : '深色模式'"
            @click="toggleTheme"
          >
            <!-- 深色主题：显示太阳 → 前往浅色 -->
            <svg
              v-if="theme === 'dark'"
              class="theme-icon-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
            </svg>
            <!-- 浅色主题：显示月亮 → 前往深色 -->
            <svg
              v-else
              class="theme-icon-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: (v) => v === 'light' || v === 'dark'
    }
  },
  methods: {
    toggleTheme() {
      this.$emit('set-theme', this.theme === 'dark' ? 'light' : 'dark')
    }
  }
}
</script>

<style lang="scss" scoped>
$gold: #c9a962;

.site-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 32px 12px;
  background: var(--header-bg);
  border-bottom: 1px solid var(--header-border);
  transition: background 0.35s ease, border-color 0.35s ease;
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.brand {
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none;
  color: inherit;
}
.brand-logo {
  display: block;
  flex-shrink: 0;
  height: 42px;
  width: auto;
  max-width: 140px;
  object-fit: contain;
  filter: var(--brand-logo-filter);
  transition: filter 0.35s ease;
}
.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.brand-title {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.12em;
  background: linear-gradient(135deg, #f0e6d2 0%, $gold 45%, #8b7355 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.brand-sub {
  font-size: 11px;
  color: var(--brand-sub);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  transition: color 0.35s ease;
}
.nav {
  display: flex;
  align-items: center;
  gap: 28px;
}
.nav-link {
  position: relative;
  font-size: 15px;
  color: var(--nav-link);
  text-decoration: none;
  padding: 8px 0;
  transition: color 0.2s;
  &.is-active {
    color: var(--nav-link-active);
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 2px;
      background: linear-gradient(90deg, transparent, $gold, transparent);
      border-radius: 1px;
    }
  }
  &:hover {
    color: var(--nav-link-hover);
  }
}

.theme-toolbar {
  flex-shrink: 0;
}
.theme-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0;
  border: 1px solid var(--theme-switch-border);
  border-radius: 50%;
  background: var(--theme-switch-track);
  color: var(--theme-switch-muted);
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease, border-color 0.35s ease,
    transform 0.15s ease;
  &:hover {
    color: var(--theme-switch-active-fg);
    background: var(--theme-switch-active-bg);
  }
  &:active {
    transform: scale(0.94);
  }
  &:focus-visible {
    outline: 2px solid rgba(201, 169, 98, 0.55);
    outline-offset: 2px;
  }
}
.theme-icon-svg {
  width: 14px;
  height: 14px;
  display: block;
}

@media (max-width: 820px) {
  .header-inner {
    flex-direction: column;
    align-items: stretch;
  }
  .header-right {
    justify-content: space-between;
    width: 100%;
  }
  .nav {
    gap: 16px;
  }
}

@media (max-width: 640px) {
  .site-header {
    padding: 12px 16px;
  }
  .brand-sub {
    display: none;
  }
  .nav {
    gap: 12px;
  }
  .nav-link {
    font-size: 14px;
  }
}
</style>
